import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/icon-skip-start-inactive.svg'
import _imports_1 from '../assets/img/icon-skip-start-active.svg'
import _imports_2 from '../assets/img/icon-arrow-left-inactive.svg'
import _imports_3 from '../assets/img/icon-arrow-left-active.svg'
import _imports_4 from '../assets/img/icon-arrow-right-inactive.svg'
import _imports_5 from '../assets/img/icon-arrow-right-active.svg'
import _imports_6 from '../assets/img/icon-skip-end-inactive.svg'
import _imports_7 from '../assets/img/icon-skip-end-active.svg'


const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = { class: "pagination__rows" }
const _hoisted_3 = {
  for: "rows-per-page",
  class: "text-body"
}
const _hoisted_4 = { class: "pagination__pages" }
const _hoisted_5 = { class: "pagination__count" }
const _hoisted_6 = { class: "pagination__controls" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_12 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  src: _imports_4,
  alt: ""
}
const _hoisted_15 = {
  key: 1,
  src: _imports_5,
  alt: ""
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  src: _imports_6,
  alt: ""
}
const _hoisted_18 = {
  key: 1,
  src: _imports_7,
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createVNode(_component_TranslatedText, { path: "pagination.rows-per-page" }),
        _withDirectives(_createElementVNode("select", {
          id: "rows-per-page",
          name: "rows-per-page",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rowCountValue) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChangeRowCount && _ctx.handleChangeRowCount(...args)))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("option", null, "15", -1),
          _createElementVNode("option", null, "30", -1),
          _createElementVNode("option", null, "45", -1),
          _createElementVNode("option", null, "60", -1),
          _createElementVNode("option", null, "75", -1),
          _createElementVNode("option", null, "90", -1),
          _createElementVNode("option", null, "105", -1)
        ]))], 544), [
          [_vModelSelect, _ctx.rowCountValue]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.pageStart) + " - " + _toDisplayString(_ctx.pageEnd) + " ", 1),
        _createVNode(_component_TranslatedText, { path: "common.of" }),
        _createTextVNode(" " + _toDisplayString(_ctx.totalRows), 1)
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "line-break" }, null, -1)),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "pagination__control",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleChangePage('first'))),
            disabled: _ctx.isFirstPage
          }, [
            (_ctx.isFirstPage)
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : (_openBlock(), _createElementBlock("img", _hoisted_9))
          ], 8, _hoisted_7)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "pagination__control",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleChangePage('prev'))),
            disabled: _ctx.isFirstPage
          }, [
            (_ctx.isFirstPage)
              ? (_openBlock(), _createElementBlock("img", _hoisted_11))
              : (_openBlock(), _createElementBlock("img", _hoisted_12))
          ], 8, _hoisted_10)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "pagination__control",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleChangePage('next'))),
            disabled: _ctx.isLastPage
          }, [
            (_ctx.isLastPage)
              ? (_openBlock(), _createElementBlock("img", _hoisted_14))
              : (_openBlock(), _createElementBlock("img", _hoisted_15))
          ], 8, _hoisted_13)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            class: "pagination__control",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleChangePage('last'))),
            disabled: _ctx.isLastPage
          }, [
            (_ctx.isLastPage)
              ? (_openBlock(), _createElementBlock("img", _hoisted_17))
              : (_openBlock(), _createElementBlock("img", _hoisted_18))
          ], 8, _hoisted_16)
        ])
      ])
    ])
  ]))
}